/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegNumberLookUpDto } from '../models/RegNumberLookUpDto';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { TestDriveInputModel } from '../models/TestDriveInputModel';
import type { TestDriveLogDtoPagedListData } from '../models/TestDriveLogDtoPagedListData';
import type { TestDriveLogSingleDto } from '../models/TestDriveLogSingleDto';
import type { TestDriveOptionsEnum } from '../models/TestDriveOptionsEnum';
import type { TestDriveStatus } from '../models/TestDriveStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TestDriveService {

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postSaveTestDrive(
requestBody?: TestDriveInputModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveTestDrive',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param search 
   * @param startDate 
   * @param endDSate 
   * @param branchId 
   * @param status
 *
 * 1 = Booking
 *
 * 2 = Started
 *
 * 3 = Completed
 *
 * 4 = Canceled
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns TestDriveLogDtoPagedListData Success
   * @throws ApiError
   */
  public static getApiTestDrive(
search?: string,
startDate?: string,
endDSate?: string,
branchId?: number,
status?: TestDriveStatus,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<TestDriveLogDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TestDrive',
      query: {
        'Search': search,
        'StartDate': startDate,
        'EndDSate': endDSate,
        'BranchId': branchId,
        'Status': status,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postApiTestDrive(
formData?: {
LeadId?: number;
EnquiryCrmId?: number;
CustomerName?: string;
Phone?: string;
Email?: string;
PostCode?: string;
PostCodeAddress?: string;
License?: string;
RegNumber?: string;
BranchId?: number;
TradePlate?: string;
EndDateTime?: string;
PreferredDateTime?: string;
Unacompanied?: boolean;
SalesUserId?: number;
Options?: Array<TestDriveOptionsEnum>;
Files?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/TestDrive',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putApiTestDrive(
formData?: {
Id?: number;
RemoveFiles?: Array<string>;
LeadId?: number;
EnquiryCrmId?: number;
CustomerName?: string;
Phone?: string;
Email?: string;
PostCode?: string;
PostCodeAddress?: string;
License?: string;
RegNumber?: string;
BranchId?: number;
TradePlate?: string;
EndDateTime?: string;
PreferredDateTime?: string;
Unacompanied?: boolean;
SalesUserId?: number;
Options?: Array<TestDriveOptionsEnum>;
Files?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/TestDrive',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns TestDriveLogSingleDto Success
   * @throws ApiError
   */
  public static getApiTestDrive1(
id: number,
): CancelablePromise<TestDriveLogSingleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TestDrive/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param status
 *
 * 1 = Booking
 *
 * 2 = Started
 *
 * 3 = Completed
 *
 * 4 = Canceled
   * @returns any Success
   * @throws ApiError
   */
  public static putApiTestDriveChangeStatus(
id?: number,
status?: TestDriveStatus,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/TestDrive/change-status',
      query: {
        'id': id,
        'status': status,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param postcode 
   * @returns RegNumberLookUpDto Success
   * @throws ApiError
   */
  public static getApiTestDriveRegNumberLookUp(
postcode?: string,
): CancelablePromise<RegNumberLookUpDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TestDrive/reg-number-look-up',
      query: {
        'postcode': postcode,
      },
    });
  }

  /**
   * @param testDriveId 
   * @returns any Success
   * @throws ApiError
   */
  public static putApiTestDriveEmailMessageSent(
testDriveId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/TestDrive/EmailMessageSent',
      query: {
        'testDriveId': testDriveId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
